// Exact SKU names of the PARENT/CATEGORY lines whose children are counted
// separately. Excluded from KPI totals ONLY (still visible in tables/views).
// Match is case-insensitive but exact — substring matching would wrongly exclude
// the child rows (e.g. "Amazon Steel Shaker", "Wellcore Glass Bottle Shaker").
const EXCLUDED_TOTAL_SKU_NAMES = [
  'steel shakers',          // exact: "Steel Shakers"
  'glass bottle shaker',    // exact: "Glass Bottle Shaker"
];

const norm = (s) => (s || '').toString().trim().toLowerCase();

// Returns true if this SKU name EXACTLY matches one of the excluded parent SKUs
// (case-insensitive, whitespace-trimmed).
export const isExcludedFromTotals = (skuName) => {
  const n = norm(skuName);
  if (!n) return false;
  return EXCLUDED_TOTAL_SKU_NAMES.includes(n);
};

export const EXCLUDED_TOTAL_SKU_LABELS = [
  'Steel Shakers',
  'Glass Bottle Shaker',
];
